import { Button } from "@mui/material";

/** Matches login / `user.role`: investor | assetOwner | admin */
export const ROLE_DISPLAY = {
  investor: "Investor",
  assetOwner: "Asset Owner",
  admin: "Admin",
};

export function parseRoleFromSearch(param) {
  const t = String(param || "").trim().toLowerCase();
  if (t === "investor") return "investor";
  if (t === "admin") return "admin";
  if (t === "assetowner" || t === "asset_owner" || t === "owner") return "assetOwner";
  return "assetOwner";
}

const roleBadgeSx = {
  color: "#38bdf8",
  borderColor: "rgba(56,189,248,0.4)",
  borderRadius: "12px",
  textTransform: "none",
  pointerEvents: "none",
  "&:hover": { background: "rgba(56,189,248,0.1)" },
};

export function AuthRoleBadge({ roleKey }) {
  const label = ROLE_DISPLAY[roleKey] || ROLE_DISPLAY.assetOwner;
  return (
    <Button variant="outlined" size="small" sx={roleBadgeSx}>
      {label}
    </Button>
  );
}
